import { useBreadcrumbsDispatch } from "@sal/portal";
import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

export const useSetBreadcrumbs = (pageName: string, pageLevel: number) => {
	const [searchParams] = useSearchParams();
	const location = useLocation();
	const breadcrumbsDispatch = useBreadcrumbsDispatch();

	useEffect(() => {
		breadcrumbsDispatch({
			newBreadcrumbs: [
				{
					name: pageName,
					level: pageLevel,
					link: location.pathname,
					params: searchParams
				}
			]
		});
	}, [pageName, pageLevel, breadcrumbsDispatch, location.pathname, searchParams]);
};

export const useSetDocumentTitle = (pageName: string) => {
	useEffect(() => {
		if (pageName && pageName.length > 0) {
			document.title = pageName;
		} else {
			document.title = "OSC Portal";
		}
	}, [pageName]);
};
